import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface RateLimitResult {
  blocked: boolean;
  remaining_seconds: number;
  attempt_count: number;
}

export const useRateLimitCheck = () => {
  const checkRateLimit = useCallback(async (email: string): Promise<RateLimitResult> => {
    try {
      const { data, error } = await supabase.functions.invoke('check-rate-limit', {
        body: { email, action: 'check' }
      });

      if (error) {
        console.error('Rate limit check error:', error);
        return { blocked: false, remaining_seconds: 0, attempt_count: 0 };
      }

      return data as RateLimitResult;
    } catch (error) {
      console.error('Rate limit check failed:', error);
      return { blocked: false, remaining_seconds: 0, attempt_count: 0 };
    }
  }, []);

  const recordLoginAttempt = useCallback(async (email: string, success: boolean): Promise<RateLimitResult> => {
    try {
      const { data, error } = await supabase.functions.invoke('check-rate-limit', {
        body: { email, action: 'record', success }
      });

      if (error) {
        console.error('Record attempt error:', error);
        return { blocked: false, remaining_seconds: 0, attempt_count: 0 };
      }

      return data as RateLimitResult;
    } catch (error) {
      console.error('Record attempt failed:', error);
      return { blocked: false, remaining_seconds: 0, attempt_count: 0 };
    }
  }, []);

  return {
    checkRateLimit,
    recordLoginAttempt
  };
};
